import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ArrowsClockwise } from "@phosphor-icons/react";

const USE = { customer_count: "Customer count", cashier: "Cashier", slab_racks: "Slab racks",
  truck_loading: "Truck loading", number_plates: "Number plates", general_security: "Security" };

function grade(r) {
  if (r.status !== "measured") return { t: r.status === "not set up" ? "NOT SET UP" : "NO PICTURES", c: "#71717A" };
  if (r.blocked) return { t: "BLOCKED VIEW", c: "#EF4444" };
  if (r.score >= 75) return { t: "EXCELLENT", c: "#22C55E" };
  if (r.score >= 50) return { t: "OK", c: "#EAB308" };
  return { t: "WEAK", c: "#EF4444" };
}

function Row({ r, i }) {
  const g = grade(r);
  return (
    <tr className="border-b border-[#27272A] text-xs font-mono-data" data-testid={`study-row-${r.camera_id}`}>
      <td className="py-3 pr-3 text-[#71717A]">{i + 1}</td>
      <td className="pr-3"><p className="text-white text-sm">{r.name}</p><p className="text-[#71717A]">{r.zone}</p></td>
      <td className="pr-3"><span className="px-2 py-1 border" style={{ color: g.c, borderColor: g.c }} data-testid={`study-grade-${r.camera_id}`}>{g.t}</span></td>
      <td className="pr-3 text-white" data-testid={`study-uptime-${r.camera_id}`}>{r.uptime_pct ?? "—"}{r.uptime_pct != null ? "%" : ""}</td>
      <td className="pr-3 text-[#A1A1AA]">{r.pics_per_min ?? "—"}</td>
      <td className="pr-3 text-[#A1A1AA]">{r.resolution || "—"}</td>
      <td className="pr-3 text-[#A1A1AA]">{r.sharpness ?? "—"}</td>
      <td className="pr-3 text-[#A1A1AA]">{r.people_max ?? "—"}</td>
      <td className="pr-3 text-[#D4D4D8] max-w-[320px]">{r.sees || "—"}
        <div className="flex flex-wrap gap-1 mt-1">{(r.good_for || []).map((u) => <span key={u} className="px-1 bg-[#18181B] text-[#A1A1AA]">{USE[u] || u}</span>)}</div>
      </td>
      <td className="text-[#71717A]">{r.last_picture ? new Date(r.last_picture).toLocaleString() : "never"}</td>
    </tr>
  );
}

export default function AvStoneStudy() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => { setBusy(true); api.get("/avstone/camera-study?hours=24", { timeout: 120000 }).then((r) => setD(r.data)).finally(() => setBusy(false)); };
  useEffect(load, []);
  return (
    <div className="p-6 lg:p-10 space-y-6" data-testid="study-page">
      <div className="flex items-center justify-between">
        <p className="text-xs font-mono-data text-[#A1A1AA]" data-testid="study-coverage">
          {d ? `Measured ${d.covered_hours} h of the last ${d.hours} h · ranked best to worst` : "Measuring…"}</p>
        <button onClick={load} disabled={busy} data-testid="study-refresh-btn"
          className="px-3 py-2 text-xs font-mono-data uppercase border border-[#27272A] text-[#A1A1AA] hover:bg-white/5 transition-colors duration-200">
          <ArrowsClockwise className={`inline mr-1 ${busy ? "animate-spin" : ""}`} />Refresh</button>
      </div>
      <div className="overflow-x-auto border border-[#27272A] bg-[#0A0A0C] p-4">
        <table className="w-full text-left" data-testid="study-table">
          <thead><tr className="text-[10px] uppercase tracking-wider text-[#71717A] border-b border-[#27272A]">
            <th className="py-2">#</th><th>Camera</th><th>Grade</th><th>Uptime</th><th>Pics/min</th><th>Resolution</th><th>Sharpness</th><th>Max people</th><th>What it sees</th><th>Last picture</th>
          </tr></thead>
          <tbody>{(d?.cameras || []).map((r, i) => <Row key={r.camera_id} r={r} i={i} />)}</tbody>
        </table>
      </div>
    </div>
  );
}
